// Header.jsx
import { Link, NavLink } from "react-router-dom";
import { useState } from "react";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-gradient-to-r from-gray-900 to-black text-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex justify-between items-center py-4">
          
          {/* Logo Section */}
          <Link to="/" className="logo flex items-center space-x-2 group">
            <img 
              src="/assets/logo/logo.png" 
              alt="logo" 
              className="h-10 md:h-12 w-auto transition-transform duration-300 group-hover:scale-105"
            />

          </Link>

          {/* Desktop Menu */}
          <ul className="hidden md:flex menubar space-x-1">
            <li className="menubar-item">
              <NavLink 
                to="/" 
                className={({ isActive }) => 
                  `px-4 py-2 rounded-lg transition-all duration-300 font-medium
                  ${isActive 
                    ? 'bg-blue-600 text-white shadow-lg' 
                    : 'hover:bg-gray-800 hover:text-blue-400'}`
                }
              >
                Home
              </NavLink>
            </li>
            <li className="menubar-item">
              <NavLink 
                to="/qualification" 
                className={({ isActive }) => 
                  `px-4 py-2 rounded-lg transition-all duration-300 font-medium
                  ${isActive 
                    ? 'bg-blue-600 text-white shadow-lg' 
                    : 'hover:bg-gray-800 hover:text-blue-400'}`
                }
              >
                Qualification
              </NavLink>
            </li>
            <li className="menubar-item">
              <NavLink 
                to="/products" 
                className={({ isActive }) => 
                  `px-4 py-2 rounded-lg transition-all duration-300 font-medium
                  ${isActive 
                    ? 'bg-blue-600 text-white shadow-lg' 
                    : 'hover:bg-gray-800 hover:text-blue-400'}`
                }
              >
                Products
              </NavLink>
            </li>
            <li className="menubar-item">
              <NavLink 
                to="/authentication" 
                className={({ isActive }) => 
                  `px-4 py-2 rounded-lg transition-all duration-300 font-medium
                  ${isActive 
                    ? 'bg-blue-600 text-white shadow-lg' 
                    : 'hover:bg-gray-800 hover:text-blue-400'}`
                }
              >
                Authentication
              </NavLink>
            </li>
            <li className="menubar-item">
              <NavLink 
                to="/contact" 
                className={({ isActive }) => 
                  `px-4 py-2 rounded-lg transition-all duration-300 font-medium
                  ${isActive 
                    ? 'bg-blue-600 text-white shadow-lg' 
                    : 'hover:bg-gray-800 hover:text-blue-400'}`
                }
              >
                Contact
              </NavLink>
            </li>
          </ul>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-white focus:outline-none"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg 
              className="w-6 h-6" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`md:hidden transition-all duration-300 ease-in-out ${
          isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
        }`}>
          <ul className="py-4 space-y-2 border-t border-gray-800">
            <li>
              <NavLink 
                to="/" 
                onClick={() => setIsMenuOpen(false)}
                className={({ isActive }) => 
                  `block px-4 py-2 rounded-lg transition-all duration-300
                  ${isActive ? 'bg-blue-600 text-white' : 'hover:bg-gray-800'}`
                }
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/qualification" 
                onClick={() => setIsMenuOpen(false)}
                className={({ isActive }) => 
                  `block px-4 py-2 rounded-lg transition-all duration-300
                  ${isActive ? 'bg-blue-600 text-white' : 'hover:bg-gray-800'}`
                }
              >
                Qualification
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/products" 
                onClick={() => setIsMenuOpen(false)}
                className={({ isActive }) => 
                  `block px-4 py-2 rounded-lg transition-all duration-300
                  ${isActive ? 'bg-blue-600 text-white' : 'hover:bg-gray-800'}`
                }
              >
                Products
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/authentication" 
                onClick={() => setIsMenuOpen(false)}
                className={({ isActive }) => 
                  `block px-4 py-2 rounded-lg transition-all duration-300
                  ${isActive ? 'bg-blue-600 text-white' : 'hover:bg-gray-800'}`
                }
              >
                Authentication
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/contact" 
                onClick={() => setIsMenuOpen(false)}
                className={({ isActive }) => 
                  `block px-4 py-2 rounded-lg transition-all duration-300
                  ${isActive ? 'bg-blue-600 text-white' : 'hover:bg-gray-800'}`
                }
              >
                Contact
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}